import dayjs from 'dayjs'

// 后端维护响应契约：任何接口返回 { maintenance: true, datetimeStart, datetimeEnd, content } 即进入维护页
export const MAINTENANCE_ERROR_CODE = 'SystemMaintenance'

export const MAINTENANCE_PHASE = Object.freeze({
  before: 'before', // 尚未到维护开始时间
  during: 'during', // 维护进行中
  over: 'over', // 已超过预计恢复时间但仍在维护
})

const WEEKDAY_LABELS = ['日', '一', '二', '三', '四', '五', '六']

// 判断响应体是否为维护标记
export function isMaintenanceResponse (data) {
  return Boolean(data) && typeof data === 'object' && !Array.isArray(data) && data.maintenance === true
}

// 归一化维护信息，缺字段一律回退为空字符串，避免页面读取 undefined
export function normalizeMaintenanceInfo (data) {
  const source = data && typeof data === 'object' ? data : {}
  return {
    datetimeStart: typeof source.datetimeStart === 'string' ? source.datetimeStart.trim() : '',
    datetimeEnd: typeof source.datetimeEnd === 'string' ? source.datetimeEnd.trim() : '',
    content: typeof source.content === 'string' ? source.content.trim() : '',
  }
}

// 解析后端 "YYYY-MM-DD HH:mm:ss" 时间（按本地时区），无效值返回 null
export function parseMaintenanceTime (value) {
  if (!value) return null
  const parsed = dayjs(value)
  return parsed.isValid() ? parsed.valueOf() : null
}

// 按当前时间判断维护阶段；缺少起讫时间时一律视为维护进行中
export function getMaintenancePhase (info, now = Date.now()) {
  const start = parseMaintenanceTime(info?.datetimeStart)
  const end = parseMaintenanceTime(info?.datetimeEnd)
  if (start !== null && now < start) return MAINTENANCE_PHASE.before
  if (end !== null && now >= end) return MAINTENANCE_PHASE.over
  return MAINTENANCE_PHASE.during
}

// "HH:mm"
export function formatMaintenanceClock (value) {
  const time = parseMaintenanceTime(value)
  return time === null ? '--:--' : dayjs(time).format('HH:mm')
}

// "YYYY/MM/DD（週幾）"
export function formatMaintenanceDate (value) {
  const time = parseMaintenanceTime(value)
  if (time === null) return ''
  const day = dayjs(time)
  return `${day.format('YYYY/MM/DD')}（${WEEKDAY_LABELS[day.day()]}）`
}

function pad (n) {
  return n < 10 ? `0${n}` : String(n)
}

// 距离目标时间的倒计时，最少显示 1 分钟；目标无效返回 null
export function getMaintenanceCountdown (target, now = Date.now()) {
  const time = parseMaintenanceTime(target)
  if (time === null) return null
  const minutes = Math.max(1, Math.ceil((time - now) / 60000))
  return {
    hours: pad(Math.floor(minutes / 60)),
    minutes: pad(minutes % 60),
  }
}
